import {WBTableRowWithRunSetInfo} from '../../../util/tablecols';
import {useRunSelectorFeatureEnabled} from '../RunSelectorFeaturesContext';
import {useCurrentRunSet} from '../RunSelectorRunSetContext';
import {isRunBaseline, isRunPinned} from '../util';

export function useRowPinningState(row: WBTableRowWithRunSetInfo) {
  const runSet = useCurrentRunSet();
  const isEnabled = useRunSelectorFeatureEnabled();
  const isBaselineEnabled = isEnabled('baselining');
  const isPinnedRunsEnabled = isEnabled('pinning');

  return {
    isRunPinned: isPinnedRunsEnabled && isRunPinned(runSet.pinnedRunIds, row),
    isRunBaseline:
      isBaselineEnabled &&
      isPinnedRunsEnabled &&
      isRunBaseline(runSet.baselineRunId, row),
  };
}
